import React from "react";

export default function HotLevelIcon({
  className = "",
  size = 22,
  active = false,
  activeColor = "white",
  inactiveColor = "#8A203C",
}) {
  return (
    <div className={className}>
      <svg
        className="w-full h-full"
        // width={size}
        // height={size * 1.3}
        viewBox={`0 0 ${size * 1.2} ${size * 1.3}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0999 11.8448C17.7714 11.4114 17.3715 11.0359 17.0001 10.6603C16.0431 9.79361 14.9576 9.17248 14.0435 8.26246C11.9153 6.15351 11.444 2.6723 12.8009 0C11.444 0.332232 10.2585 1.08336 9.24439 1.90672C5.54507 4.91125 4.08819 10.2125 5.83073 14.7626C5.88786 14.9071 5.94499 15.0515 5.94499 15.2393C5.94499 15.5571 5.73075 15.846 5.44508 15.9616C5.11657 16.106 4.77378 16.0193 4.5024 15.7882C4.42134 15.7196 4.35354 15.6363 4.30244 15.5427C2.68845 13.4771 2.43135 10.5159 3.51687 8.1469C1.13159 10.1114 -0.168174 13.4337 0.0175064 16.5683C0.103205 17.2905 0.188904 18.0127 0.431716 18.735C0.63168 19.6017 1.01732 20.4684 1.44582 21.2339C2.98839 23.7329 5.65933 25.5241 8.53023 25.8852C11.5868 26.2752 14.8576 25.7118 17.2001 23.574C19.8139 21.1762 20.728 17.3338 19.3854 14.0404L19.1997 13.6648C18.8998 13.0004 18.0999 11.8448 18.0999 11.8448ZM13.5865 20.945C13.1865 21.2917 12.5295 21.6673 12.0153 21.8117C10.4156 22.3895 8.8159 21.5806 7.87321 20.6273C9.5729 20.2228 10.587 18.9517 10.8869 17.6661C11.1298 16.5105 10.6727 15.5571 10.487 14.4449C10.3156 13.3759 10.3442 12.4659 10.7298 11.4692C11.0012 12.0181 11.2869 12.567 11.6297 13.0004C12.7295 14.4449 14.4577 15.0804 14.8291 17.0449C14.8862 17.2472 14.9148 17.4494 14.9148 17.6661C14.9576 18.8505 14.4434 20.1506 13.5865 20.945Z"
          fill={active ? activeColor : inactiveColor}
        />
      </svg>
    </div>
  );
}
